<template>
  <base-section
    id="technical"
    style="padding-bottom: 0px"
  >
    <v-container>
      <base-section-heading title="Technical Sponsors" />
      <v-slide-group
        show-arrows
      >
        <template v-for="(partner, i) in partners">
          <v-slide-item
            :key="i"
            class="align-self-center"
          >
            <a
              :href="partner.to"
              target="_blank"
            >
              <base-img
                v-bind="partner"
                color="grey"
                contain
                height="70"
                width="128"
              />
            </a>
          </v-slide-item>

          <v-responsive
            v-if="i < 1"
            :key="`divider-${i}`"
            class="text-center"
            height="56"
            width="48"
          >
            <v-divider vertical />
          </v-responsive>
        </template>
      </v-slide-group>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'TechnicalSponsors',
    data: () => ({
      sponsorsfooter: [
        {
          name: 'Sponsors',
          url: 'program-committee',
        },
        {
          name: 'Topic Chairs',
          url: 'topic-chairs',
        },
      ],
      partners: [
        {
          src: require('@/assets/logo-4-light.png'),
          to: 'https://www.computer.org',
        },
        {
          src: require('@/assets/logo-5-light.png'),
          to: 'https://www.ieee-tttc.org',
        },
      ],
    }),
  }
</script>
